import openBook from '@images/home/open-book.png'
import Component from '@glimmer/component'
import { HomeTile } from 'teacher-ui-client/components/home/tile'
import { UiButtonLinkTo } from 'teacher-ui-client/components/ui-button/link-to'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import { posthogEvent } from 'teacher-ui-client/modifiers/posthog'

interface Signature {
  Args: {
    reportingDashboardModels: unknown[]
  }
}

export class RecentWriting extends Component<Signature> {
  get openBookPng() {
    return openBook
  }

  <template>
    <HomeTile @themeKey={{themeKey "writing"}} @title={{t "pages.home.panels.recentWriting.title"}}>
      <div class="space-y-3 bg-white p-3">
        <div class="flex h-28 items-start">
          <img class="mr-6" src={{this.openBookPng}} alt={{t "pages.home.panels.recentWriting.imageAlt"}} />
          <p class="mb-3">{{t "pages.home.panels.recentWriting.description"}}</p>
        </div>
        <div class="text-center">
          <UiButtonLinkTo
            @route="reporting.ui-scope.writing-legends.recent-writing"
            @appearance={{ButtonAppearance.regular}}
            @models={{@reportingDashboardModels}}
            {{posthogEvent "Reporting" product="writing-legends" page="recent-writing"}}
          >
            {{t "pages.home.panels.recentWriting.buttonLabel"}}
          </UiButtonLinkTo>
        </div>
      </div>
    </HomeTile>
  </template>
}

export default RecentWriting
